import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { SPRINT_IN_TEMPLATE_DURATION_MULTIPLE } from 'components/organisms/sprint-planning/constants';
import { logger } from 'services';
import { createSprintInProjectTemplate } from '../../actions';
import { createProjectTemplateSprint } from '../../slices';
import { onCreateAndUpdateSprint } from '../date-shift';
function* createSprintInTemplateSaga(action) {
    try {
        var _payload_sprint;
        const { payload } = action;
        yield put(createProjectTemplateSprint(payload));
        yield onCreateAndUpdateSprint({
            payload: {
                sprintId: payload === null || payload === void 0 ? void 0 : (_payload_sprint = payload.sprint) === null || _payload_sprint === void 0 ? void 0 : _payload_sprint.sprintId,
                payload: {
                    startDay: 1,
                    duration: SPRINT_IN_TEMPLATE_DURATION_MULTIPLE
                }
            },
            type: ''
        });
    } catch (error) {
        logger.error('updateProjectTemplateSprint failed', {
            error
        });
        message.error('There was an error updating the sprint');
    }
}
export function* watchCreateSprintInProjectTemplateSaga() {
    yield takeLatest(createSprintInProjectTemplate.type, createSprintInTemplateSaga);
}
